export const appendLineStrings = (lineStrings, newLineString) => {
    for (let i = 0; i < lineStrings.length; i++) {
        const lineString = lineStrings[i];
        const [startPoint1x, startPoint1y] = lineString[0];
        const [endPoint1x, endPoint1y] = lineString[lineString.length - 1];
        const [startPoint2x, startPoint2y] = newLineString[0];
        const [endPoint2x, endPoint2y] = newLineString[newLineString.length - 1];
        if (endPoint1x === startPoint2x && endPoint1y === startPoint2y) {
            const modifiedLineString = [...lineString, ...newLineString.slice(1)];
            const result = [...lineStrings];
            result[i] = modifiedLineString;
            return result;
        }
        else if (endPoint2x === startPoint1x && endPoint2y === startPoint1y) {
            const modifiedLineString = [...newLineString, ...lineString.slice(1)];
            const result = [...lineStrings];
            result[i] = modifiedLineString;
            return result;
        }
        else if (startPoint1x === startPoint2x && startPoint1y === startPoint2y) {
            const reversed = [...newLineString].reverse();
            const modifiedLineString = [...reversed, ...lineString.slice(1)];
            const result = [...lineStrings];
            result[i] = modifiedLineString;
            return result;
        }
        else if (endPoint1x === endPoint2x && endPoint1y === endPoint2y) {
            const reversed = [...newLineString].reverse();
            const modifiedLineString = [...lineString, ...reversed.slice(1)];
            const result = [...lineStrings];
            result[i] = modifiedLineString;
            return result;
        }
    }
    return [...lineStrings, newLineString];
};
//# sourceMappingURL=appendLineStrings.js.map